import React from 'react';

function About() {
  return (
    <div className="page-about">
      {/* HEADER SECTION */}
      <section className="section">
        <div className="section-header">
          <span className="section-tag">Who We Are</span>
          <h2 className="section-title">About Saveera Biotech</h2>
          <p className="section-subtitle" style={{ maxWidth: '800px', fontSize: '1.15rem', lineHeight: '1.8' }}>
            Saveera Biotech is an Indian technology services enterprise focused on digital marketing,
            IT consultancy and technology solutions.
          </p>
        </div>

        <div style={{ maxWidth: '900px', margin: '0 auto', padding: '0 1.5rem' }}>
          <p style={{ color: 'var(--text-secondary)', marginBottom: '1.5rem', fontSize: '1.05rem', lineHeight: '1.8' }}>
            Our registered business activity falls under computer programming, consultancy and related activities,
            including other information technology and computer services.
          </p>
          <p style={{ color: 'var(--text-secondary)', marginBottom: '1.5rem', fontSize: '1.05rem', lineHeight: '1.8' }}>
            We work with businesses to understand their digital and technology requirements and provide practical
            solutions that support their growth.
          </p>
        </div>
      </section>

      {/* MISSION & VISION */}
      <section className="section bg-alt-dark" style={{ borderTop: '1px solid var(--border-color)' }}>
        <div className="testimonials-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))' }}>
          {/* MISSION CARD */}
          <div className="testimonial-card" style={{ padding: '3rem' }}>
            <span className="quote-mark" style={{ fontSize: '7rem', color: 'rgba(255, 102, 0, 0.04)', right: '15px', top: '10px' }}>🎯</span>
            <h3 className="feature-title" style={{ color: 'var(--accent-color)', fontSize: '1.6rem', marginBottom: '1.5rem' }}>Our Mission</h3>
            <p className="feature-desc" style={{ fontSize: '1.1rem', lineHeight: '1.7', color: 'var(--text-secondary)' }}>
              To help businesses use technology and digital marketing more effectively to create visibility,
              improve efficiency and achieve sustainable growth.
            </p>
          </div>

          {/* VISION CARD */}
          <div className="testimonial-card" style={{ padding: '3rem' }}>
            <span className="quote-mark" style={{ fontSize: '7rem', color: 'rgba(255, 102, 0, 0.04)', right: '15px', top: '10px' }}>👁️</span>
            <h3 className="feature-title" style={{ color: 'var(--accent-color)', fontSize: '1.6rem', marginBottom: '1.5rem' }}>Our Vision</h3>
            <p className="feature-desc" style={{ fontSize: '1.1rem', lineHeight: '1.7', color: 'var(--text-secondary)' }}>
              To become a trusted technology and digital solutions partner for businesses looking to grow in an
              increasingly digital economy.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
